import React from 'react';

const SUBTYPES = ['software', 'hardware-software', 'consulting', 'other'];

const ProductTypeSelector = ({ formData, handleInputChange }) => {
  return (
    <div className="form-section">
      <h3>Product Type</h3>
      <div className="form-row">
        <div className="form-group">
          <label>Type</label>
          <select
            name="type"
            value={formData.type || 'product'}
            onChange={handleInputChange}
            className="form-control"
          >
            <option value="product">Product</option>
            <option value="showcase">Showcase</option>
          </select>
        </div>
        <div className="form-group">
          <label>Subtype</label>
          <select
            name="subtype"
            value={formData.subtype || 'software'}
            onChange={handleInputChange}
            className="form-control"
          >
            {SUBTYPES.map(st => (
              <option key={st} value={st}>{st}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ProductTypeSelector;
